import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-workflow-confirmation-modal',
  templateUrl: './workflow-confirmation-modal.component.html',
  styleUrls: ['./workflow-confirmation-modal.component.scss']
})
export class WorkflowConfirmationModalComponent {
  @Input() modalTitle = "";
  @Input() modalBody: string | HTMLElement = "";
  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modal: NgbActiveModal) { }

  confirmClicked() {
    this.onConfirm.emit();
    this.modal.close();
  }
}
